<template>
    <div class="lbil_doctor_info_modal">
      <div class="lbil_doctor_info_modal_wrp">
        <div class="lbil_doctor_info_modal_center">
          <div class="lbil_doctor_info_modal_body">
            <div class="remove_data_task_header">
              <h2>Are you sure you want to confirm consult request?</h2>
            </div>
            <div class="remove_data_task_btn">
              <button class="btn remove_yes_btn" @click="confirmedConsultRequestPopupMethod">Yes, I want</button>
              <button class="btn remove_yes_no" @click="closeConsultRequestPopupMethod">Cancel</button>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
/*eslint-disable */
import {bus} from '@/main';
import toast from '@/services/toast';
export default {
  props: ['consultRequestId'],
  data () {
    return {
    }
  },
  mounted () {
  },
  methods: {
    closeConsultRequestPopupMethod(){
      document.body.classList.remove('body_right_scroll_remove')
      bus.$emit('confrimConsultRequestPopupStateBus', false);
    },
    confirmedConsultRequestPopupMethod(){
      let data ={
        is_active : true
      }
      this.$store.dispatch('doctorReqApprovalAction', {data:{id:this.consultRequestId, data: data}}).then((res) => {
        toast.success(res.data.msg);
        this.closeConsultRequestPopupMethod();
      }).catch((err) => {
        toast.error( err.data.user_msg || err.data.msg);
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.lbil_doctor_info_modal {
    position: fixed;
    top: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.92);
    left: 0;
    right: 0;
    z-index: 10001;
    min-height: 100dvh;
    width: 100%;
    overflow-y: auto;
    &::-webkit-scrollbar {
        width: 8px;
        background: transparent;
    }
    &::-webkit-scrollbar-thumb {
        background-color: #333333;
    }
}

.lbil_doctor_info_modal_body {
    background: #000;
    width: 480px;
    margin: 0px auto;
    border-radius: 5px;
    padding: 20px 25px;
    font-family: 'MyriadProRegular', 'Lato', sans-serif;
    color: #ffffff;
    box-shadow: 0px 0px 13px rgba(255, 213, 0, 0.6);
}
.lbil_doctor_info_modal_wrp{
    display: table;
    width: 100%;
    height: 100%;
}
.lbil_doctor_info_modal_center{display:table-cell;vertical-align:middle;}
.remove_data_task_header h2 {
    font-size: 18px;
    color: #ffffff;
    font-family: 'MyriadProRegular', 'Lato', sans-serif;
    text-align: center;
    margin: 0 0 30px;
}

.remove_yes_btn {
    font-size: 16px;
    background: #ff7070;
    color: #fff;
    font-family: 'MyriadProRegular', 'Lato', sans-serif;
    padding: 10px 5px;
    min-width: 100px;
    line-height: 1;
    border-radius: 3px !important;
    outline: none !important;
    box-shadow: none !important;
}

.remove_yes_no {
    font-size: 16px;
    background: #459238;
    color: #fff;
    font-family: 'MyriadProRegular', 'Lato', sans-serif;
    padding: 10px 5px;
    min-width: 100px;
    line-height: 1;
    margin-left: 10px;
    border-radius: 3px !important;
    outline: none !important;
    box-shadow: none !important;
}

.remove_data_task_btn {
    text-align: center;
}

.remove_data_task_btn {
    text-align: center;
}

</style>